var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpecialEmployee(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 43,
    viewBox: "0 0 48 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.6797 28.3778L42.6953 33.3016L48 33.6963L43.9414 37.1351L45.207 42.3051L40.6836 39.5032L36.1602 42.3051L37.4258 37.1351L33.3594 33.6963L38.6641 33.3016L40.6797 28.3778ZM0 39.3977C0.488281 33.0515 -0.757812 33.3289 4.55859 31.336C7.21094 30.3434 10.5977 29.0812 13.0312 27.565C16.5039 30.7771 18.4609 34.556 17.582 39.3977H0ZM16.1875 23.9229C16.3047 22.946 13.4141 19.2297 12.8906 17.4477C11.7617 15.6502 11.3594 12.7936 12.5938 10.8944C13.0859 10.1402 12.875 8.79591 12.875 7.75644C12.875 -2.58353 30.9883 -2.58744 30.9883 7.75644C30.9883 9.06555 30.6875 10.0581 31.3984 11.0859C32.5859 12.8053 31.9727 15.8534 30.9727 17.4516C30.332 19.3235 27.3008 22.8639 27.5117 23.9268C27.6875 29.2336 16.1523 29.0577 16.1875 23.9229ZM30.2422 27.0218C32.4102 28.4051 35.457 29.554 37.9414 30.3903L37.3086 31.9338L28.4414 32.5904L35.2383 38.3426L34.9805 39.3938H25.5391C24.7812 35.0132 26.1055 30.8592 30.2422 27.0218Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecialEmployee);
export default __webpack_public_path__ + "static/media/Special-employee.0839377fae1b1d5ff14cd95bfd778f1c.svg";
export { ForwardRef as ReactComponent };